(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sm-bis"] && !Shopify.designMode) return;
  try {
    // Eén gedelegeerde handler voor elk BIS-formulier op de pagina, nu en later.
  (function () {
    if (window.__smBis) return;
    window.__smBis = true;

    var REVISIE = '2026-01-15';

    function melden(form, tekst, stand) {
      var el = form.querySelector('.bis-melding');
      if (!el) return;
      el.setAttribute('data-stand', stand);
      el.textContent = tekst;
    }

    function post(pad, key, body) {
      return fetch('https://a.klaviyo.com/client/' + pad + '/?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: REVISIE },
        body: JSON.stringify(body)
      });
    }

    document.addEventListener('submit', function (e) {
      var form = e.target.closest ? e.target.closest('form[data-bis]') : null;
      if (!form) return;
      e.preventDefault();

      var veld = form.querySelector('.bis-mail');
      var knop = form.querySelector('.bis-knop');
      var mail = veld ? veld.value.trim() : '';
      var key = form.getAttribute('data-bis-key');
      var variant = form.getAttribute('data-bis-variant');

      // Dezelfde toets die Klaviyo zelf doet. `type="email"` vangt het meeste al
      // af, maar novalidate staat aan omdat de browsermelding niet te stylen is.
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)) {
        if (veld) {
          veld.setAttribute('aria-invalid', 'true');
          veld.focus();
        }
        melden(form, 'Vul een geldig e-mailadres in.', 'fout');
        return;
      }
      if (veld) veld.removeAttribute('aria-invalid');
      if (knop) knop.disabled = true;

      post('back-in-stock-subscriptions', key, {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: mail } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant } }
          }
        }
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Klaviyo ' + res.status);

          var rij = form.querySelector('.bis-rij');
          var uitleg = form.querySelector('.bis-uitleg');
          melden(form, 'Gelukt — je krijgt bericht zodra dit weer op voorraad is.', 'klaar');

          // Focus eerst verplaatsen, dán pas de rij weghalen. De focus stond op de
          // knop of het veld en die zitten allebei ín die rij; verdwijnt hij eerst,
          // dan valt de focus terug naar <body> en verliest een toetsenbord- of
          // schermlezergebruiker zijn plek precies op het moment dat de melding
          // voorgelezen moet worden.
          var melding = form.querySelector('.bis-melding');
          if (melding) melding.focus();
          if (rij) rij.hidden = true;
          if (uitleg) uitleg.hidden = true;
        })
        .catch(function () {
          melden(form, 'Er ging iets mis. Probeer het zo nog eens.', 'fout');
          if (knop) knop.disabled = false;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sm-filterbalk"] && !Shopify.designMode) return;
  try {
    // Verrijking, geen voorwaarde: zonder JS submit de bezoeker met de knop uit
  // <noscript>. Hier vervangt een wijziging die klik.
  //
  // Gedelegeerd op document, niet per formulier: dit blok draait één keer per
  // paginalading, terwijl de theme-editor de sectie opnieuw rendert bij elke
  // instelling. Een direct gebonden listener is daarna weg en de balk doet dan
  // niets meer — de noscript-knop staat er niet als JS aan staat.
  document.addEventListener('change', (e) => {
    e.target.closest('[data-fbar-form]')?.submit();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sm-pakket-galerij"] && !Shopify.designMode) return;
  try {
    /* Podium + paneel. Drie handelingen, geen state buiten de DOM:
     wissel het podium, open het paneel, sluit het paneel.

     Altijd `showModal()`, ook op desktop. De niet-modale variant stond hier
     eerst: die blijft in de normale flow en kon dus absoluut binnen het podium
     liggen, doorschijnend over het gerecht. Alleen staan de tegels ónder het
     podium — op 1728px van y=1084 tot 2076, terwijl het podium op 962 eindigt —
     dus bij een tik was het podium al uit beeld en opende het paneel buiten het
     scherm. Modal geeft daarnaast backdrop, focusslot en Escape van de browser
     zelf; dat scheelt precies de code die hier eerst stond en die op één punt
     al fout was. */
  (function () {
    var wortels = document.querySelectorAll('[data-pgal]');
    if (!wortels.length) return;

    wortels.forEach(function (wortel) {
      var stage = wortel.querySelector('[data-pgal-stage]');
      var stageWrap = wortel.querySelector('[data-pgal-stage-wrap]');
      var open = null;
      var opener = null;

      /* Geeft terug of deze knop het podium ook echt vertegenwoordigt. Dat is
         niet hetzelfde als "er wisselde iets": staat het beeld er al, dan is de
         knop nog steeds de huidige. Alleen een knop zónder bron is dat niet, en
         die mag zich dus ook niet zo laten markeren. Zie `markeer` hieronder. */
      function zet(knop) {
        if (!stage) return false;
        var src = knop.getAttribute('data-pgal-src');
        if (!src) return false;
        if (stage.getAttribute('src') === src) return true;
        /* Uitfaden, dan pas de bron wisselen: zonder de vertraging staat het
           nieuwe beeld er al voor de overgang begint en zie je een harde knip.

           ⚠ Hier stond `decode()`, omdat die ook op tekenklaar wacht. Alleen:
           op een `Image` die niet in het document hangt lost die belofte in
           Chrome nóóit op — gemeten 09-09-2026 op de preview, 3294ms na de klik
           nog steeds pending terwijl `complete` true was en `naturalWidth` 1620.
           En omdat `Promise.all` op beide wacht, bleef het podium in
           `is-wisselend` staan en wisselde het beeld niet: een tik op een
           gerecht deed visueel niets. `load` vuurt op zo'n losse Image wél —
           dat is de gewone voorlaad-truc — en `complete` vangt de cache-treffer
           af, die anders geen event meer geeft. */
        var vers = new Image();
        var srcset = knop.getAttribute('data-pgal-srcset');
        if (srcset) vers.srcset = srcset;
        vers.src = src;
        stageWrap.classList.add('is-wisselend');
        var klaar = new Promise(function (klaarIs) {
          if (vers.complete) return klaarIs();
          vers.addEventListener('load', klaarIs, { once: true });
          /* Ook bij een fout doorgaan: een podium dat blijft hangen is erger dan
             een beeld dat de browser zelf als gebroken toont. */
          vers.addEventListener('error', klaarIs, { once: true });
        });
        Promise.all([klaar, new Promise(function (r) { setTimeout(r, 180); })]).then(function () {
          stage.src = src;
          if (srcset) stage.srcset = srcset;
          stage.alt = knop.getAttribute('data-pgal-alt') || '';
          stageWrap.classList.remove('is-wisselend');
        });
        return true;
      }

      /* ⚠ Alleen aanroepen als `zet` true gaf. Met de instelling "hoofdbeeld
         wisselt met het gerecht" úít — en dat is de standaard — draagt een
         gerechttegel geen `data-pgal-src`, dus het podium blijft het pakketbeeld
         tonen. Werd `markeer` dan tóch gedraaid, dan kreeg de aangetikte tegel
         `aria-current="true"` plus de omlijning, en werd élk stripbeeld op
         `aria-pressed="false"` gezet: het scherm én de schermlezer meldden een
         keuze die het podium niet laat zien. Gemeten op live 10-09-2026 (nul
         tegels met bron, podiumbeeld ongewijzigd, tóch één aria-current).
         Codex-review 10-09-2026. */
      function markeer(knop) {
        wortel.querySelectorAll('.pgal-tegel[aria-current]').forEach(function (t) {
          t.removeAttribute('aria-current');
        });
        wortel.querySelectorAll('[data-pgal-foto]').forEach(function (d) {
          d.setAttribute('aria-pressed', String(d === knop));
        });
        if (knop.classList.contains('pgal-tegel')) knop.setAttribute('aria-current', 'true');
      }

      wortel.addEventListener('click', function (e) {
        var foto = e.target.closest('[data-pgal-foto]');
        if (foto && wortel.contains(foto)) {
          if (open) open.close();
          if (zet(foto)) markeer(foto);
          return;
        }

        var tegel = e.target.closest('[data-pgal-open]');
        if (tegel && wortel.contains(tegel)) {
          var dlg = wortel.querySelector('#' + CSS.escape(tegel.getAttribute('data-pgal-open')));
          if (!dlg) return;
          if (open) open.close();
          if (zet(tegel)) markeer(tegel);
          opener = tegel;
          open = dlg;
          dlg.showModal();
          var sluitknop = dlg.querySelector('[data-pgal-close]');
          if (sluitknop) sluitknop.focus();
          return;
        }

        if (e.target.closest('[data-pgal-close]')) {
          if (open) open.close();
          return;
        }

        /* Klik-weg. Een klik op de backdrop van een modale dialoog landt op de
           dialoog zelf; alles binnenín heeft een ander doel. */
        if (open && e.target === open) open.close();
      });

      /* Eén plek waar het opruimen gebeurt, en dat is `close` — niet de
         sluitfunctie. De browser sluit deze dialoog namelijk ook zelf, bij
         Escape, en dan komt er geen klik langs. Zou het herstellen van de focus
         in een eigen functie staan, dan sprong de focus na Escape naar het begin
         van de pagina. */
      wortel.addEventListener('close', function (e) {
        if (e.target !== open) return;
        open = null;
        if (opener) opener.focus();
        opener = null;
      }, true);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sm-sticky-hulp"] && !Shopify.designMode) return;
  try {
    /* Rect-meting op scroll, geen IntersectionObserver — om de reden die in
     sm-sticky-koop staat: die observer viel op de pakket-PDP stil zonder
     aanwijsbare oorzaak, en een getal dat je uitrekent op het moment dat je het
     nodig hebt kan niet stil verlopen. Eén meting per animatieframe waarin
     gescrold is. */
  (() => {
    let gepland = false;
    const meet = () => {
      gepland = false;
      const balk = document.querySelector('[data-sticky-hulp]');
      if (!balk) return;
      const anker = document.querySelector(balk.dataset.anker);
      /* Geen anker: geen balk. Het `hidden` gaat pas af als er iets te meten is,
         zodat de balk zonder JS ook nooit half zichtbaar blijft hangen. */
      if (!anker) return;
      balk.hidden = false;
      balk.classList.toggle('on', anker.getBoundingClientRect().bottom < 0);
    };
    const plan = () => {
      if (gepland) return;
      gepland = true;
      requestAnimationFrame(meet);
    };
    addEventListener('scroll', plan, { passive: true });
    addEventListener('resize', plan, { passive: true });
    addEventListener('load', plan);
    document.addEventListener('shopify:section:load', plan);
    meet();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sm-sticky-koop"] && !Shopify.designMode) return;
  try {
    /* De balk verschijnt zodra het koopblok naar BÓVEN uit beeld is — niet wanneer
     het er nog ónder staat, want bij het laden van de pagina is het koopblok ook
     "niet zichtbaar" en dan hoort er geen balk te staan.

     ⚠ Een rect-meting op scroll, en géén IntersectionObserver, terwijl het
     ontwerp (Pdp.jsx) die wél gebruikt. Gemeten op de pakket-PDP in de preview
     van 28-08: de observer bleef daar dood. Hij werd aangemaakt, kreeg zijn
     anker en zijn eerste callback, en reageerde daarna nergens meer op — terwijl
     een handmatige tweede init hem meteen liet werken, en een verse observer met
     exact dezelfde parameters vanuit de console óók. Nagegaan en uitgesloten:
     het snippet stond in `data-snippets` (de bundel-guard liet dus door), er was
     precies één balk en één anker, en een MutationObserver op #sm-main zag over
     vier seconden geen enkele vervanging van beide knopen. Op de losse-maaltijd-
     PDP werkte dezelfde code wél. Het verschil is niet gevonden; wat vaststaat is
     dat de uitkomst per pagina verschilde.

     Een rect-meting heeft dat probleem niet: er is geen registratie die stil kan
     verlopen, alleen een getal dat je uitrekent op het moment dat je het nodig
     hebt. Kosten: één `getBoundingClientRect()` per animatieframe waarin er
     gescrold is, achter een rAF-slot en passieve listeners. Dat is de ruil
     waarvoor je een elegantere API laat staan — de goedkopere oplossing die stil
     faalt, is de dure.

     De aanleiding om hier überhaupt naar te kijken was de Codex-review van
     28-08: die wees erop dat de pakket-PDP zijn stappen 1-3 afhandelt met
     `hoofd.innerHTML = …` (`wissel()` in sm-pakket), waardoor deze balk — die
     binnen #sm-main staat — door een verse kopie vervangen wordt. Vandaar het
     `sm:hoofd-vervangen`-signaal en de gedelegeerde submit-handler hieronder:
     beide overleven zo'n vervanging. */
  (() => {
    let gepland = false;

    const meet = () => {
      gepland = false;
      const balk = document.querySelector('[data-sticky-koop]');
      if (!balk) return;
      const anker = document.querySelector(balk.dataset.anker);
      /* Geen anker: de balk blijft weg. Liever geen balk dan een balk die nooit
         meer weggaat. Het `hidden`-attribuut staat in de markup en gaat er hier
         af, zodat de balk zonder JS ook niet half zichtbaar blijft hangen. */
      if (!anker) return;
      balk.hidden = false;
      /* ⚠ De balk stáát, altijd — besluit Joey 04-09-2026. Tot dan kwam hij pas
         als het koopblok naar boven uit beeld was (gemeten drempel op de
         pakket-PDP: scrollY 640), en dat betekende dat de eerste schermvulling
         van elke productpagina géén koopknop droeg, terwijl kopen de enige
         handeling is die die pagina vraagt.

         Het anker verdwijnt hiermee niet uit de code, en dat is opzet: het is de
         bron voor variant en aantal in de submit-handler hieronder, en de
         null-check erboven is precies waarom er géén balk verschijnt op een
         pagina die er geen heeft.

         `data-anker-vroeg` is hierdoor ongebruikt. Het attribuut blijft in de
         markup staan, zodat terugdraaien één regel is: vervang deze regel door
         de `toggle` op `trigger.getBoundingClientRect().bottom < 80`.

         ⚠ Eén uitzondering op "altijd", en die is geen verwatering van het
         besluit maar de voorwaarde ervoor: staat het échte koopblok in beeld,
         dan gaat de balk weg. Zonder die regel legt hij zich er bovenop. Gemeten
         04-09 op de losse-maaltijd-PDP bij 375x667: tussen scrollY 720 en 780
         bedekte de balk 49 van de 56px van de knop "In winkelwagen" — twee
         koopknoppen op elkaar, de echte vrijwel verstopt. De pagina compenseert
         de vaste balk namelijk nergens met ruimte onderaan (`padding-bottom: 0`
         op body én main), dus hij ligt over de inhoud.

         Het besluit blijft daarmee overeind: de eerste schermvulling van een
         productpagina draagt een koopknop. Alleen ís dat op het moment dat het
         koopblok zelf in beeld staat de échte knop, en dan is een tweede knop
         over de eerste heen geen extra kans maar een verstopte. */
      /* Meten aan de KNOP, niet aan het formulier eromheen. `.pakket-form` is
         een lang formulier: zodra de bovenkant ervan de onderrand van het scherm
         raakt zou de balk al verdwijnen, terwijl "In winkelwagen" nog ver onder
         de vouw ligt — dan is er even helemaal geen koopknop. Het anker blijft
         de bron voor variant en aantal in de submit-handler; alleen de meting
         zakt naar de knop. Codex-ronde 4 op 04-09. */
      const doel = anker.querySelector('[type="submit"]') || anker;
      const a = doel.getBoundingClientRect();
      /* Niet "raakt het scherm" maar "is hij te tikken, náást de balk". Twee
         eisen die elkaar bijten, en de volgorde waarin ze zijn opgelost staat
         hier omdat elke tussenvorm een echte storing was:

           · verdwijnt de balk bij het eerste pixeltje knop, dan is er even geen
             koopknop meer — de knop staat dan nog onder de vouw;
           · blijft hij tot de knop ergens in beeld is, dan ligt hij er middenin
             de overgang bovenop en is de echte knop half verstopt.

         Beide verdwijnen als je de knop meet in het gebied dat de balk vrijláát.
         Pas als daar 44px van de knop staat — of de hele knop, als die lager is —
         neemt hij het over. Tot dat moment blijft de balk, en dat hij dan een
         stukje van de knop bedekt is geen verlies: hij biedt dezelfde handeling
         op dezelfde plek. Codex-ronde 5 op 04-09. */
      const vrij = innerHeight - (balk.offsetHeight || 0);
      const zichtbaar = Math.min(a.bottom, vrij) - Math.max(a.top, 0);
      const inBeeld = zichtbaar >= Math.min(44, a.height);
      balk.classList.toggle('on', !inBeeld);
    };

    const plan = () => {
      if (gepland) return;
      gepland = true;
      requestAnimationFrame(meet);
    };

    /* Passief, want ze roepen nooit `preventDefault` aan en zonder die vlag houdt
       de browser het scrollen tegen tot hij dat weet.

       Deze twee stonden er tussen 04-09 en de review van diezelfde dag even niet:
       `meet` hing toen nergens meer aan, dus was een listener een `querySelector`
       per animatieframe met altijd hetzelfde antwoord. Nu de balk weer wijkt voor
       het koopblok in beeld, hangt hij wél aan de scrollpositie en moeten ze mee.

       Na een stap-1-t/m-3-wissel op de pakket-PDP staat er een verse balk in de
       DOM; die moet alsnog `hidden` af. Omdat deze opzet niets op een element
       registreert, volstaat één hermeting — er is geen observer die opnieuw
       gekoppeld moet worden. */
    addEventListener('scroll', plan, { passive: true });
    addEventListener('resize', plan, { passive: true });
    document.addEventListener('sm:hoofd-vervangen', plan);
    addEventListener('load', plan);
    meet();

    /* Variant én aantal uit het hoofdformulier meenemen, op `submit` en niet bij
       elke wijziging: de kiezer kan een input, een select of een stepper zijn, en
       alleen de stand op het moment van versturen telt. Gedelegeerd op `document`
       en niet op het formulier zelf, zodat een balk die na een wissel vervangen
       is meteen meedoet — dezelfde reden waarom de drawer zijn submit-handler
       daar heeft hangen. */
    document.addEventListener('submit', (e) => {
      const form = e.target.closest && e.target.closest('.sticky-form');
      if (!form) return;
      const balk = form.closest('[data-sticky-koop]');
      const anker = balk && document.querySelector(balk.dataset.anker);
      if (!anker) return;

      const qtyVeld = form.querySelector('[data-sticky-qty]');
      if (qtyVeld) {
        const bron = anker.querySelector('[name="quantity"]');
        const n = bron ? parseInt(bron.value, 10) : 1;
        qtyVeld.value = Number.isFinite(n) && n > 0 ? n : 1;
      }
      /* Alleen overnemen als het hoofdformulier écht een variant-id voert én die
         gevuld is; anders blijft de server-gerenderde waarde staan. Een leeg `id`
         maakt van /cart/add een 422, en dat is erger dan de terugval. */
      const idVeld = form.querySelector('[data-sticky-id]');
      if (idVeld) {
        const bronId = anker.querySelector('[name="id"]');
        if (bronId && bronId.value) idVeld.value = bronId.value;
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
